define([], ()=> {
    /**
     * String utility functions
     */
    return {
        /** Capitalizes a first letter of the string. */
        capitalizeFirstLetter: (str)=> {
            return str.charAt(0).toUpperCase() + str.substring(1);
        },


        /** Sets the first letter of the string to lowercase */
        lowercaseFirstLetter: (str)=> {
            return str.charAt(0).toLowerCase() + str.substring(1);
        }
    };
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/util/StringUtil.js
 **/